module.exports = __webpack_public_path__ + "static/media/Notice of Proposal to Refuse an Application.1bc686a4.pdf";